<script lang="ts">
	//Stores
	import { user_data } from 'src/stores/account/user';
	//Services
	import { format } from '../../../../services/i18n';
	import { postReq } from '../../../../services/http';
	//Helpers
	import { copy } from '../../../../helpers/copy_text';
	//Design system components
	import { AlertV2, ButtonV2, IconButton, Text, toast } from '@Shelly/shelly-design-system';

	let authKeyHolder = '';
	let show = false;

	const shown = () => {
		show = true;
		handleAuthKey();
	};

	//GET AUTH KEY ----------------------------------------------------------------------------------
	export const handleAuthKey = async () => {
		let res = await postReq('/user/get_user_key', {});
		if (res.isok) {
			authKeyHolder = res.data.key.toString();
		} else {
			toast.open({ type: 'danger', title: $format('error_global') });
		}
	};
</script>

{#if show}
	<Text styleType="body-medium" class="mb-s">
		{$format('authorization_cloud_key', {
			default: 'Authorization cloud key',
		})}
	</Text>
	<Text class="mb-s text-color-muted" styleType="body-small"
		>{$format('authorization_cloud_key_description', {
			default: 'Get cloud key for your home',
		})}</Text
	>

	<AlertV2 backgroundColor="color-00" class="mb-s" heading={`Server: ${$user_data.user_api_url}`} />
	<div class="d-flex align-items-center">
		<Text styleType="body-small" breakWord>{authKeyHolder}</Text>
		<IconButton
			aria-label={$format('button_copy_to_clipboard', { default: 'Copy to clipboard' })}
			class="ml-s"
			variant="help-2"
			icon={'fas fa-copy'}
			on:click={() => copy(authKeyHolder, $format('copy_to_clippboard'))}
		/>
	</div>
{:else}
	<div class="d-flex gap-s justify-content-between align-items-center">
		<div>
			<Text styleType="body-medium" class="mb-xs">
				{$format('authorization_cloud_key', {
					default: 'Authorization cloud key',
				})}
			</Text>
			<Text class="text-color-muted" styleType="body-small"
				>{$format('authorization_cloud_key_description', {
					default: 'Get cloud key for your home',
				})}</Text
			>
		</div>
		<ButtonV2 variant="secondary" size="m" on:click={shown}>{$format('get_key')}</ButtonV2>
	</div>
{/if}
